import Validator from 'validatorjs';

export default () => {
    Validator.register('contains_alpha_numeric', v => v.match(/[a-z]/i) && v.match(/[0-9]/i), 'The :attribute should contain at least one letter and one number');

    Validator.register('contains_special_characters', v => v.match(/\W/i), 'The :attribute should contain at least one special character (@#$%^! ...etc)');

    Validator.register('us_phone', v => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v), 'The :attribute format is not valid');
};
